import { cardDataShape } from "../../shapes";
import { appearancePropType } from "../../common";

/**
 * PropTypes for CardInfo component
 *
 * @property {CardData} card - Card data object with icon, title, value, etc. (required)
 * @property {('primary'|'secondary'|'success'|'danger'|'warning'|'info')} [appearance] - Visual color variant
 */
export const cardInfoPropTypes = {
  card: cardDataShape.isRequired,
  appearance: appearancePropType,
};
